<template>
    <common-modal :heading="getModalHeading">
        <common-content-wrapper width="medium">
            <verify-phone-form
                :isSmsSent="isSmsSent"
                @success="emitEvent({ name: 'success' })"
                @sms-countdown-over="emitEvent({ name: 'sms-countdown-over' })"
            ></verify-phone-form>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    import VerifyPhoneForm from 'components/forms/user/VerifyPhoneForm'

    export default {
        components: { VerifyPhoneForm },

        props: {
            isSmsSent: { type: Boolean, defaul: false },
        },

        computed: {
            getModalHeading() {
                return `${this.$t('modals.verify_phone.title')} ${this.$auth.getUser()?.pendingMobile || ''}`
            },
        },
    }
</script>
